try {
    // Standard Vars
    //window.CHECK24_HOST = 'www.check24.at';

    // Set hovering header
    window.Check24.headerHover?.init?.();
    window.Check24.cookieBanner.init();
    /* EXECUTE COOKIE LOGIC - REMOVE WHEN EVENT IS TRIGGERED THROUGH HOLDING */
    window.TCMS.helper.checkConsentCookie();
} catch (err) {
    console.error(err);
}
